module.exports = __webpack_public_path__ + "img/img12.8d8bf10f.png";